const isOther = (field: string) => field?.toLowerCase() === "other";

export default isOther;
